import React from "react";
import { RiRulerFill } from "react-icons/ri";

const Measurment = ({ isClickActive, handleButtonClick }) => {
  return (
    <div
      onClick={handleButtonClick}
      className={`w-fit lg:w-[11rem] cursor-pointer ${isClickActive ? "bg-[#f39c12]" : "bg-[#00000080]"
        } text-white rounded-t-0 rounded-l-[2em] rounded-r-[2em] items-center py-1 justify-between px-1 rounded-b-0 flex relative clear-both`}
    >
      <p className="text-[16px] px-2 hidden lg:flex font-[myFont]">اندازه‌گیری</p>
      <button
        className={`p-2 shadow-lg ${isClickActive ? "bg-[#f39c12]" : "bg-white"
          } w-fit rounded-full text-black`}
      >
        <RiRulerFill color={isClickActive ? "#ffffff" : "#0272b2"} size={20} />
      </button>
    </div>
  );
};

export default Measurment;
